import React, {useState} from "react";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import {v4} from "uuid";
import Grid from "@mui/material/Grid";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from "@mui/icons-material/Remove";
import EditIcon from "@mui/icons-material/Edit";
import {s_char_threads, s_char_threadsteps} from "../../_signals/s_char";
import {ICharThread} from "../../_interfaces/iCharThread";
import ThreadsAdd from "./ThreadsAdd";
import {ICharThreadStep} from "../../_interfaces/iCharThreadStep";
import ThreadsEdit from "./ThreadsEdit";
import ThreadStepAdd from "./ThreadStepAdd";
import ThreadStepEdit from "./ThreadStepEdit";
import {useSignals} from "@preact/signals-react/runtime";
import {ThreadDelete} from "../../_api/BEThreads";

export default function Threads() {
    useSignals()
    const [addThread, setAddThread] = useState(false)
    const [editThread, setEditThread] = useState<ICharThread | null>(null)

    const [addThreadStep, setAddThreadStep] = useState<ICharThread | null>(null)
    const [editThreadStep, setEditThreadStep] = useState<ICharThreadStep | null>(null)


    const deleteThread = (thread: ICharThread) => {
        s_char_threads.value = s_char_threads.value.filter(t => t.id !== thread.id)
        ThreadDelete(thread)
    }

    const stepRow = (step: ICharThreadStep) => {
        return <Grid container key={v4()} style={{margin: 4}}>
            <Grid item xs={2}>
                Rang {step.num}
            </Grid>
            <Grid item xs={9}>
                {step.name ? step.name : <span style={{color: 'red', fontStyle: 'italic'}}>Eintrag fehlt</span>}
            </Grid>
            <Grid item xs={1}>
                <Button onClick={() => setEditThreadStep(step)}><EditIcon/></Button>
            </Grid>
        </Grid>
    }

    const threadRow = (thread: ICharThread) => {

        return <Paper key={v4()} style={{padding: 4}}>
            <Grid container key={v4()}>
                <Grid item xs={7}>
                    {thread.name ? thread.name : <span style={{color: 'red', fontStyle: 'italic'}}>Eintrag fehlt</span>}
                </Grid>
                <Grid item xs={2}>
                    LP-Start {thread.lpstart}
                </Grid>
                <Grid item xs={3}>
                    <Button onClick={() => setEditThread(thread)}><EditIcon/></Button>
                    <Button onClick={() => setAddThreadStep(thread)}><AddIcon/></Button>
                    <Button onClick={() => {
                        if (!thread.name || window.confirm(thread.name + ' löschen')) {
                            deleteThread(thread);
                        }
                    }}><RemoveIcon/></Button>
                </Grid>
                <Grid item xs={12}>
                    {
                        s_char_threadsteps.value.map(
                            ts => ts.tid === thread.id ?
                                <Paper key={v4()} style={{margin: '4px 4px 4px 20px', padding: 4}}>
                                    {stepRow(ts)}
                                </Paper>
                                : null
                        )
                    }
                </Grid>
            </Grid>
        </Paper>
    }

    return <Paper style={{overflowX: 'auto', marginTop: "14px"}}>
        <h3 style={{margin: "5px"}}>Fäden
            <AddIcon onClick={() => setAddThread(true)}/>
        </h3>
        <Paper key={v4()}
               style={{padding: 4}}>{s_char_threads.value.map((thread) => threadRow(thread))}
        </Paper>

        {addThread ? <ThreadsAdd
            open={addThread}
            isOpen={(e) => setAddThread(e)}/> : null}
        {editThread ? <ThreadsEdit
            open={editThread}
            isOpen={(e) => {
                if (!e) setEditThread(null)
            }}/> : null}
        {addThreadStep ? <ThreadStepAdd
            open={addThreadStep}
            isOpen={(e) => {
                if (!e) setAddThreadStep(null)
            }}/> : null}
        {editThreadStep ? <ThreadStepEdit
            open={editThreadStep}
            isOpen={(e) => {
                if (!e) setEditThreadStep(null)
            }}/> : null}
    </Paper>

}

